type OfflineAvatarAudioSource = {
  attrs_json?: string;
  has_audio?: unknown;
  hasAudio?: unknown;
  with_audio?: unknown;
  withAudio?: unknown;
  voice_id?: unknown;
};

const toOptionalBoolean = (value: unknown): boolean | undefined => {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return undefined;

  const normalized = value.trim().toLowerCase();
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;
  return undefined;
};

const hasNonEmptyString = (value: unknown): boolean => typeof value === 'string' && value.trim().length > 0;

export const parseOfflineAvatarAudioAttrs = (attrsJson?: string): Record<string, unknown> => {
  if (!attrsJson) return {};

  try {
    const attrs = JSON.parse(attrsJson);
    return attrs && typeof attrs === 'object' && !Array.isArray(attrs) ? (attrs as Record<string, unknown>) : {};
  } catch {
    return {};
  }
};

const getAudioBoolean = (avatar: OfflineAvatarAudioSource, attrs: Record<string, unknown>): boolean | undefined => {
  return (
    toOptionalBoolean(avatar.has_audio) ??
    toOptionalBoolean(avatar.hasAudio) ??
    toOptionalBoolean(avatar.with_audio) ??
    toOptionalBoolean(avatar.withAudio) ??
    toOptionalBoolean(attrs.has_audio) ??
    toOptionalBoolean(attrs.hasAudio) ??
    toOptionalBoolean(attrs.with_audio) ??
    toOptionalBoolean(attrs.withAudio)
  );
};

export const offlineAvatarHasBuiltInAudio = (avatar?: OfflineAvatarAudioSource | null): boolean => {
  if (!avatar) return false;

  const attrs = parseOfflineAvatarAudioAttrs(avatar.attrs_json);
  const explicitAudioFlag = getAudioBoolean(avatar, attrs);
  if (typeof explicitAudioFlag === 'boolean') return explicitAudioFlag;

  return (
    hasNonEmptyString(avatar.voice_id) ||
    hasNonEmptyString(attrs.voice_id) ||
    hasNonEmptyString(attrs.voice_timbre) ||
    hasNonEmptyString(attrs.voiceTimbre) ||
    hasNonEmptyString(attrs.audio_url) ||
    hasNonEmptyString(attrs.audioUrl) ||
    hasNonEmptyString(attrs.source_audio_url) ||
    hasNonEmptyString(attrs.sourceAudioUrl)
  );
};
